import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { RoutesService } from '@shared/services/routes.service';
import { UnsavedChangingsService } from '@shared/services/unsaved-changings.service';
import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class UnsavedChangingsGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(
    private unsavedChangingsService: UnsavedChangingsService,
  ) {
  }

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    // console.log('Check canDeactivate', this.unsavedChangingsService.isFormSaved(), this.unsavedChangingsService);
    if (this.unsavedChangingsService.isFormSaved(component)) {
      return true;
    } else {
      this.unsavedChangingsService.triggerShowDialog();
      return this.unsavedChangingsService.userAnswerResult$.asObservable();
    }
  }
}
